import React from 'react';
import Script from 'next/script';

/**
 * This script is required to play any Wistia video.  Ideally it's only on the page once.
 */
const WistiaVideoBase = () => {
  return (
    <Script
      src="//fast.wistia.com/assets/external/E-v1.js"
      async
      strategy="lazyOnload"
    />
  );
};

export default WistiaVideoBase;
